import React, { useEffect } from "react";
import PageContainer from "../../../components/PageContainer/PageContainer";
import WithdrawSection from "../components/WithdrawSection";
import EventDetails from "../components/AsideSection/EventDetails";
import TableValue from "../components/AsideSection/TableValue";
import PhysicalProductsValue from "../components/AsideSection/PhysicalProductsValue";
import ActionButtons from "../components/AsideSection/ActionButtons";
import { useMediaQuery } from "react-responsive";
import { useAppSelector, useAppDispatch } from "../../../hooks/useAppDispatch";
import { RootState } from "../../../redux/store";
import { fetchAndLoadGiftTable } from "../../../redux/slices/giftTableSlice";
import TwoColumnLayout from "../../../components/TwoColumnLayout/TwoColumnLayout";

// Function to get the current theme's background color
const getThemeBackgroundColor = (): string => {
  return getComputedStyle(document.documentElement)
    .getPropertyValue("--color-background")
    .trim();
};

interface MainLayoutProps {
  content: React.ReactNode; // Content to render in the main section
}

const MainLayoutWeb: React.FC<MainLayoutProps> = ({ content }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <PageContainer>
      <TwoColumnLayout
        aside={
          <>
            <EventDetails />
            <TableValue />
            <PhysicalProductsValue />
            <ActionButtons />
          </>
        }
        asideWidth="25%"
        stickyTop="100px"
      >
        <WithdrawSection />
        {content}
      </TwoColumnLayout>
    </PageContainer>
  );
};

const MainLayoutMobile: React.FC<MainLayoutProps> = ({ content }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <PageContainer startColor={getThemeBackgroundColor()} endColor="white">
      <div className="flex flex-col p-0 w-screen">
        <main className="flex-1 w-screen">
          <WithdrawSection />
          {content}
        </main>
      </div>
    </PageContainer>
  );
};

const MainLayout: React.FC<MainLayoutProps> = ({ content }) => {
  const isMobile = useMediaQuery({ query: "(max-width: 768px)" });
  const giftTable = useAppSelector((state: RootState) => state.giftTable);
  const dispatch = useAppDispatch();

  useEffect(() => {
    // Clear the history stack for this page
    window.history.replaceState(null, "", window.location.href);

    // Load the gift table
    window.scrollTo(0, 0);
    dispatch(fetchAndLoadGiftTable(giftTable.ID));
  }, []);

  return isMobile ? (
    <MainLayoutMobile content={content} />
  ) : (
    <MainLayoutWeb content={content} />
  );
};

export default MainLayout;
